import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['radio']

    select(event) {
        var data = document.getElementsByName('new-organization-book-connection-list');
        var i;
        console.log(data)
        for (i = 0; i < data.length; i++) {
            if (data[i].checked) {
                var link = document.getElementById('sync-page')
                let url = link.getAttribute('url')
                link.setAttribute('href', url + "?sync_url=" + data[i].value)
                link.classList.remove('hidden')
            }
        }
    }
}